import './SidebarMenu.css'
import { getAuth, signOut } from 'firebase/auth';
import { useLocation, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useAuth } from '../../Components/AuthContext/AuthContext'

import logo from '../../resources/Frame 1.svg'
import logo_name from '../../resources/Logo.svg'
import dashboard_icon_w from '../../resources/grid white.svg'
import dashboard_icon from '../../resources/grid.svg'
import calendar_icon from '../../resources/Calendar.svg'
import calendar_icon_w from '../../resources/Calendar white.svg'
import my_meals_icon from '../../resources/My Meal.svg'
import my_meals_icon_w from '../../resources/My Meal white.svg'
import analytics_icon from '../../resources/business.svg'
import analytics_icon_w from '../../resources/business white.svg'
import explore_icon from '../../resources/Explore New Recipes.svg'
import explore_icon_w from '../../resources/Explore New Recipes white.svg'
import shopping_icon from '../../resources/Shopping List.svg'
import shopping_icon_w from '../../resources/Shopping List white.svg'
import logout_icon from '../../resources/arrows.svg'

import { IoCaretUp, IoCaretDown } from "react-icons/io5";

function SidebarMenu() {
    const auth = getAuth();
    const clicked_button_css = 'side-navigation-bar-button-clicked green_gradient white flex align_center'
    const button_css = 'side-navigation-bar-button flex align_center'

    const clicked_button_p_css = "tab-title";
    const button_p_css = "tab-title1 gray_scale_2";

    var currentPath = useLocation().pathname;
    const navigate = useNavigate();
    const [expanded, setExpanded] = useState(false);
    const { currentUser, userInfo } = useAuth();

    useEffect(() => {

        function handleResize() {
            if (currentUser && currentPath != '/subscription' && currentPath != '/premium') {
                if (window.innerWidth > 800) {
                    document.getElementById('side-navigation-bar-menu').style.display = 'flex';
                    document.getElementById('side-navigation-bar').style.boxShadow = 'none';
                    document.getElementById('side-navigation-bar-btn').style.display = 'none';
                    document.getElementById('side-navigation-bar').style.borderBottomRightRadius = '0px';

                    setHeightForSideBar(false)
                    setExpanded(true)
                } else {
                    document.getElementById('side-navigation-bar-menu').style.display = 'none';
                    document.getElementById('side-navigation-bar-btn').style.display = 'block';
                    document.getElementById('side-navigation-bar-btn').style.bottom = '-17px';

                    setHeightForSideBar(true)
                    setExpanded(false)
                }
            }

        }

        window.addEventListener('resize', handleResize);

        // Cleanup the event listener on component unmount
        return () => {
            window.removeEventListener('resize', handleResize);
        };

    }, [userInfo, currentUser]);


    useEffect(() => {
        const sideNavBtn = document.getElementById('side-navigation-bar-btn');
        const isMobile = window.innerWidth <= 800;
        const hide = ((currentUser && currentUser.uid) && (currentPath != '/subscription') && (currentPath != '/premium')) ? true : false;

        if (isMobile) {
            setHeightForSideBar(true);
            sideNavBtn.style.display = hide ? 'block' : 'none';
        } else {
            setHeightForSideBar(!hide);
            sideNavBtn.style.display = 'none';
        }
    }, [currentUser]);


    function logout() {
        if (window.confirm('Are you sure you want to logout?')) {
            signOut(auth)
            window.location.reload();
            if (window.innerWidth <= 800 && expanded) {
                toggleExpand()
            }
        }
    }

    function goToPage(path) {
        if (window.innerWidth <= 800 && expanded) {
            toggleExpand()
        }
        navigate(path);
    }

    function toggleExpand() {
        if (expanded) {
            document.getElementById('side-navigation-bar-menu').style.display = 'none';
            document.getElementById('side-navigation-bar').style.boxShadow = 'none'
            document.getElementById('side-navigation-bar-btn').style.display = 'block'
            document.getElementById('side-navigation-bar-btn').style.bottom = '-17px';
            document.getElementById('side-navigation-bar').style.borderBottomRightRadius = '0px';

            setHeightForSideBar(true)
            setExpanded(false)
        } else {
            document.getElementById('side-navigation-bar-menu').style.display = 'flex';
            document.getElementById('side-navigation-bar-btn').style.bottom = '0px';
            document.getElementById('side-navigation-bar').style.borderBottomRightRadius = '20px';


            setHeightForSideBar(false)
            setExpanded(true)
        }
    }

    function setHeightForSideBar(close) {
        const sideBar = document.getElementById("side-navigation-bar")
        const sudeBarMenu = document.getElementById("side-navigation-bar-menu")
        if (close) {
            sideBar.style.height = '60px';
            sudeBarMenu.style.display = 'none'
        } else {
            sudeBarMenu.style.display = 'flex'

            if (sideBar && userInfo) {
                sideBar.style.height = userInfo.active_subscription ? 'calc(100vh - 10px)' : 'calc(100vh - 40px)';
            } else {
                sideBar.style.height = '100vh';
            }
        }

    }

    return (
        <div id='side-navigation-bar' className="side-navigation-bar">
            <div id="side-navigation-bar-header-div">
                <div id='side-navigation-bar-logo-div' onClick={() => currentUser ? goToPage('/') : goToPage('/')}>
                    {/* <img className="side-navigation-bar-logo-img" alt="" src={logo} /> */}
                    <img className="logo-icon" alt="" src={logo_name} />
                </div>
            </div>
            <div id='side-navigation-bar-menu' className="side-navigation-bar-menu">
                <div className='text_decoration_none' onClick={() => goToPage('/')}>
                    <div className={currentPath === '/' ? clicked_button_css : button_css}>
                        <img className="sidebar-menu-icon" alt="" src={currentPath === '/' ? dashboard_icon_w : dashboard_icon} />
                        <p className={currentPath === '/' ? clicked_button_p_css : button_p_css}>Dashboard</p>
                    </div>
                </div>
                <div className='text_decoration_none' onClick={() => goToPage('/calendar')}>
                    <div className={currentPath === '/calendar' ? clicked_button_css : button_css}>
                        <img className="sidebar-menu-icon" alt="" src={currentPath === '/calendar' ? calendar_icon_w : calendar_icon} />
                        <p className={currentPath === '/calendar' ? clicked_button_p_css : button_p_css}>Calendar</p>
                    </div>
                </div>
                {/* <div className='text_decoration_none' onClick={() => goToPage('/my-meals')}>
                    <div className={currentPath === '/my-meals' ? clicked_button_css : button_css}>
                        <img className="sidebar-menu-icon" alt="" src={currentPath === '/my-meals' ? my_meals_icon_w : my_meals_icon} />
                        <p className={currentPath === '/my-meals' ? clicked_button_p_css : button_p_css}>My Meal</p>
                    </div>
                </div> */}
                <div className='text_decoration_none' onClick={() => goToPage('/analytics')}>
                    <div className={currentPath === '/analytics' ? clicked_button_css : button_css}>
                        <img className="sidebar-menu-icon" alt="" src={currentPath === '/analytics' ? analytics_icon_w : analytics_icon} />
                        <p className={currentPath === '/analytics' ? clicked_button_p_css : button_p_css}>Analytics</p>
                    </div>
                </div>
                <div className='text_decoration_none' onClick={() => goToPage('/explore')}>
                    <div className={currentPath === '/explore' ? clicked_button_css : button_css}>
                        <img className="sidebar-menu-icon" alt="" src={currentPath === '/explore' ? explore_icon_w : explore_icon} />
                        <p className={currentPath === '/explore' ? clicked_button_p_css : button_p_css}>Explore New Recipes</p>
                    </div>
                </div>
                <div className='text_decoration_none' onClick={() => goToPage('/ingredient-tracker')}>
                    <div className={currentPath === '/ingredient-tracker' ? clicked_button_css : button_css}>
                        <img className="sidebar-menu-icon" alt="" src={currentPath === '/ingredient-tracker' ? shopping_icon_w : shopping_icon} />
                        <p className={currentPath === '/ingredient-tracker' ? clicked_button_p_css : button_p_css}>Ingredient Tracker</p>
                    </div>
                </div>

            </div>


            <button id='side-navigation-bar-btn' className="side-navigation-bar-btn" onClick={toggleExpand}>
                {
                    !expanded ? <IoCaretDown /> :
                        <IoCaretUp />
                }
            </button>

        </div>
    );
}


export default SidebarMenu;